import React from "react";
import { Link } from "react-router-dom";
import Fontstyling from "../common/comman";

const Footer = () => {
  function nextYear(){
    console.log(new Date().getFullYear())
    return Number(new Date().getFullYear()) + 1
  }
  return (
    <footer className="pt-1 pe-4">
      <div className="text-end" style={Fontstyling.secondaryparagraph}>
        © 2023 - {nextYear()} HUB International Limited. 150 N Riverside Plaza, 17th Floor,
        Chicago, IL 60606. All rights reserved.{" "}
        <Link to={"#"} className="text-dark">
          Privacy Policy Terms & Conditions
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
